/**
 * planilhasApi — carga da planilha de instalações sem termo (M2 — ADR-038). Só admin (a API barra os demais).
 *
 *  - POST /planilhas-instalacoes                  → { data: RegistroPlanilha }
 *  - POST /planilhas-instalacoes/{id}/analise     → { data: AnalisePlanilha }   (422 FORMATO_PLANILHA: o que falta)
 *  - POST /planilhas-instalacoes/{id}/confirmacao → { data: ConfirmacaoPlanilha }
 *  - GET  /planilhas-instalacoes/{id}             → { data: PlanilhaDetalhe }
 *  - PUT na URL assinada (o arquivo vai direto ao acervo, com os headers da assinatura).
 */

import { ApiClient } from './apiClient';
import {
  AnalisePlanilha,
  ConfirmacaoPlanilha,
  PlanilhaDetalhe,
  RegistroPlanilha,
  UploadPlanilha,
} from './planilhas-types';

interface Envelope<T> {
  readonly data: T;
}

export class PlanilhasApi {
  constructor(
    private readonly client: ApiClient,
    private readonly fetchFn: typeof fetch = (...args) => fetch(...args),
  ) {}

  async registrar(nomeArquivo: string, tamanho: number, sha256: string): Promise<RegistroPlanilha> {
    const resp = await this.client.request<Envelope<RegistroPlanilha>>('/planilhas-instalacoes', {
      method: 'POST',
      body: JSON.stringify({ nomeArquivo, tamanho, sha256 }),
    });
    return resp.data;
  }

  /** Envia o arquivo pela URL assinada; 412 = já está no acervo (conta como enviado). */
  async enviar(upload: UploadPlanilha, arquivo: Blob): Promise<void> {
    const resp = await this.fetchFn(upload.url, { method: upload.metodo, headers: { ...upload.headers }, body: arquivo });
    if (!resp.ok && resp.status !== 412) {
      throw new Error(`Falha ao enviar a planilha (HTTP ${resp.status}).`);
    }
  }

  async analisar(id: string): Promise<AnalisePlanilha> {
    const resp = await this.client.request<Envelope<AnalisePlanilha>>(
      `/planilhas-instalacoes/${encodeURIComponent(id)}/analise`,
      { method: 'POST' },
    );
    return resp.data;
  }

  async confirmar(id: string): Promise<ConfirmacaoPlanilha> {
    const resp = await this.client.request<Envelope<ConfirmacaoPlanilha>>(
      `/planilhas-instalacoes/${encodeURIComponent(id)}/confirmacao`,
      { method: 'POST' },
    );
    return resp.data;
  }

  async obter(id: string): Promise<PlanilhaDetalhe> {
    const resp = await this.client.request<Envelope<PlanilhaDetalhe>>(`/planilhas-instalacoes/${encodeURIComponent(id)}`);
    return resp.data;
  }
}
